// import Attendance from "./Attendance";

export default {
  // component: Attendance,
  priority: 97,
  name: app.translate("محاسبه حقوق و دستمزد"),
  path: "modifier",
  permissions: ["TimeAttendanceMenu/EditReportMenu"], // ["ReportsMenu", "DeviceListMenu", "DeviceChartMenu", "ClockingMenu", "WorkingHourMenu", "CalendarMenu"
  // ,"ShiftDefinitionMenu", "PositionsMenu", "WritMenu", "PolicyDefinitionMenu", "SettingDefinitionMenu", "StackRulesMenu", "StackHistoryMenu"],
  component: load(() => import(/* webpackChunkName: "Writs" */ "./Modifier")),
  icon: "av-timer",
  drawer: true,
};
